import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query';
import { Select } from '@/components/ui';
import { api } from '@/lib/api';
/** Drop-in country picker backed by /core/countries/.
 *  When the value changes, the parent also receives the default ISO-4217
 *  currency for that country — handy for autopopulating salary CCY. */
export function CountrySelect({ value, onChange, disabled, placeholder, allowEmpty, className }) {
    const q = useQuery({
        queryKey: ['countries'],
        queryFn: async () => (await api.get('/core/countries/')).data,
        staleTime: 24 * 60 * 60 * 1000,
    });
    return (_jsxs(Select, { value: value, disabled: disabled || q.isLoading, onChange: (e) => {
            const c = q.data?.find((x) => x.code === e.target.value);
            onChange(e.target.value, c?.currency);
        }, className: className, children: [(allowEmpty || !value) && _jsx("option", { value: "", children: placeholder ?? '— select country —' }), q.data?.map((c) => (_jsxs("option", { value: c.code, children: [c.name, " ", c.currency ? `(${c.currency})` : ''] }, c.code)))] }));
}
